<template>
  <div id="software-status">
    <b-row align-h="between" no-gutters="">
      <b-col cols="2">
        <i :class="computedSelectColor" class="stacked icons">
          <i id="circle" class="circle icon m-auto" />
          <i id="outline" class="circle outline icon" />
        </i>
      </b-col>
      <b-col cols="8" class="pr-3">
        <p class="text-truncate">{{ name }}</p></b-col
      >
      <b-col cols="2" class="text-right">
        <b-link :to="detailUrl" class="text-info">{{
          "dashboard.details" | i18n
        }}</b-link>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/**
 * @description Affiche les informations de base d'un logiciel
 * @author Samuel Colassin
 * @vue-prop {Number} status - Le statut du logiciel
 * @vue-prop {String} name - Le nom du logiciel
 * @vue-prop {String} detailUrl - L'url pour avoir le détail du logiciel
 * @vue-computed {String} computedSelectColor - Détermine la couleur du statut du logiciel
 */
export default {
  name: "SoftwareStatus",
  props: {
    status: {
      required: true,
      type: Number
    },
    name: {
      required: true,
      type: String
    },
    detailUrl: {
      required: true,
      type: String
    }
  },
  computed: {
    computedSelectColor() {
      return this.status == 2
        ? "text-danger"
        : this.status == 1
        ? "text-warning"
        : this.status == 0
        ? "text-success"
        : "text-light";
    }
  }
};
</script>

<style scoped>
#circle {
  font-size: 16px;
}

#outline {
  font-size: 24px;
}
</style>
